import React from 'react';
import { createPortal } from 'react-dom';
import Message from 'legacy/src/utility/Message';

const RenderPortalValidation = ({ condition, elementClassName, message }) => {
  const elements = document.getElementsByClassName(elementClassName);
  const element = elements && elements.length > 0 && elements[1];
  return condition && element
    ? createPortal(<Message className="--error">{message}</Message>, element)
    : null;
};

export default RenderPortalValidation;
